import styled from "@emotion/styled";

import { commonColors } from "application/theme";

export const Wrapper = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const AmountField = styled("div")`
  display: flex;
  align-items: center;
  gap: 4px;

  h2 {
    display: flex;
    align-items: center;
    width: 100%;
    color: ${commonColors.black};
    font-family: Unica77;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    letter-spacing: 0.07px;

    > svg {
      min-width: 20px;
      width: 20px;
      height: 20px;
      margin: 0 6px 2px 0;
    }
  }

  p {
    word-break: break-all;
    min-width: 100px;
    color: ${commonColors.grey900};
    text-align: right;
    font-family: Unica77;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.08px;
  }

  &.bonus {
    h2,
    p {
      color: ${commonColors.green700};
    }
  }
`;
